import { useFavoriteStore } from '~/stores/favorite';
import { useCompareStore } from '~/stores/compare';

const favoriteStorageKey = 'favorite';
const compareStorageKey = 'compare';

export const useLocalStoreListener = () => {
  const { setFavoriteState } = useFavoriteStore();
  const { setCompareState } = useCompareStore();

  const onStorageChange = (event: StorageEvent) => {
    if (event.key === favoriteStorageKey) {
      setFavoriteState(JSON.parse(event.newValue));
    } else if (event.key === compareStorageKey) {
      setCompareState(JSON.parse(event.newValue));
    }
  };

  onMounted(() => {
    if (!import.meta.env.SSR && window) {
      window.addEventListener('storage', onStorageChange);
    }
  });

  onUnmounted(() => {
    if (!import.meta.env.SSR && window) {
      window.removeEventListener('storage', onStorageChange);
    }
  });
};

export const setFavoriteStore = (val) => {
  if (!import.meta.env.SSR && window) {
    window.localStorage.setItem(favoriteStorageKey, JSON.stringify(val));
  }
};
export const setCompareStore = (val) => {
  if (!import.meta.env.SSR && window) {
    window.localStorage.setItem(compareStorageKey, JSON.stringify(val));
  }
};
